/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue Jun 20 2023
 **/
import { useTheme } from "@emotion/react";

import { InviteChatMember, NewMemberNoGroup } from "@/frameworks/core/components";
import { usePersistStore } from "@/frameworks/core/persistence";
import { ModalID } from "@/frameworks/core/commons";
import { _P, _T } from "@rfice/language";
import { Button, Typography, useModal, Row } from "@/frameworks/designStuff/components";

import EmptyWrapperSection from "./EmptyWrapperSection";

export default function EmptyDMChatList() {
	const modal = useModal();
	const theme = useTheme();
	const group = usePersistStore((state) => state.groups);

	const isExistGroup = group.length !== 0;

	const handleClick = async () => {
		modal.show({
			id: isExistGroup ? ModalID.INVITE_CHAT_MEMBER : ModalID.USER_NO_GROUP,
			content: isExistGroup ? (
				<InviteChatMember
					chatKind="DM"
					onHide={() => {
						modal.hide(ModalID.INVITE_CHAT_MEMBER);
					}}
				/>
			) : (
				<NewMemberNoGroup />
			)
		});
	};

	return (
		<EmptyWrapperSection>
			{isExistGroup ? (
				<Typography typoSize="Body3" typoColor="neutral_70_100" align="center">
					{_P("다이렉트 채팅이 없습니다.<br/>멤버들과 다이렉트 채팅을 시작해보세요.")}
				</Typography>
			) : (
				<Typography typoSize="Body3" typoColor="neutral_70_100" align="center">
					{_P("스페이스를 만들고 <br/>친구 초대하면 채팅할 수 있어요.")}
				</Typography>
			)}

			<Button
				css={{ marginTop: 12, background: theme.colors.accent_10_100 }}
				filled="transparent"
				shape="circle"
				size="large"
				onClick={handleClick}
			>
				<Row gap={8}>
					<Typography typoSize="Title3" typoColor="neutral_80_100">
						{isExistGroup ? _T("다이렉트 채팅 시작") : _T("스페이스 만들기")}
					</Typography>
				</Row>
			</Button>
		</EmptyWrapperSection>
	);
}
